module.exports = __webpack_public_path__ + "img/mail_sent_icon.5bc02bbe.svg";